import React from 'react';
import Icon from 'components/lib/icons/icon';

export default function Columns(props) {
  return (
    <Icon viewBox="0 0 512 512" {...props}>
      <path
        d="M48 416V160H232V432H64c-8.8 0-16-7.2-16-16zm232 16V160H464V416c0 8.8-7.2 16-16 16H280zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
        fill="currentColor"
      />
    </Icon>
  );
}
